var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"map",style:({height: _vm.height, width:'100%'}),attrs:{"id":"map"}})}
var staticRenderFns = []

export { render, staticRenderFns }